import { api } from "../Configurations/axios";
import { CapitalCompositionFinepModel } from "../Models/CapitalCompositionModel";

const GetCapitalCompositionFinep = async (id: string) => {
    try {
        var result = await api.get(`/CapitalCompositionFINEP/GetByCompanyFINEPId/${id}`);
        var response = result.data;

        return response.data;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

const CreateCapitalCompositionFinep = async (company: CapitalCompositionFinepModel) => {
    try {
        var result = await api.post(`/CapitalCompositionFINEP/CreateCapitalCompositionFINEP`, company);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

interface ValidateCapitalCompositionFinepProps{
    companyFinepId: string;
    isContentValid: boolean;
    userEmail: string;
}

const ValidateCapitalCompositionFinep = async (company: ValidateCapitalCompositionFinepProps) => {
    try {
        var result = await api.put(`/CapitalCompositionFINEP/ValidateCapitalCompositionFINEP`, company);
        var response = result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    GetCapitalCompositionFinep,
    CreateCapitalCompositionFinep,
    ValidateCapitalCompositionFinep
}